import React from 'react'
import {gql, useQuery} from '@apollo/client'
import {useParams} from 'react-router-dom'
import Tags from 'admin/components/shared/Tags'

const QUERY = gql`
  query GetGroups {
    groups {
      id
      name
      colour
    }
  }
`

export default ({
  selectedIds = [],
  partialSelectedIds = [],
  onSelect,
  onUnselect,
  buttonText,
  buttonPosition,
  tagPrefix
}) => {
  const {organisationID} = useParams()
  const {data} = useQuery(QUERY, {variables: {organisationId: organisationID}})
  const groups = data ? data.groups : []

  const selected = groups
    .filter(group => [...partialSelectedIds, ...selectedIds].includes(String(group.id)))
    .map(group => ({
      ...group,
      name: [tagPrefix, group.name].join(' '),
      partial: partialSelectedIds.includes(String(group.id))
    }))

  const selectable = groups
    .filter(group => ![...selectedIds, ...partialSelectedIds].includes(String(group.id)))
    .sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })

  return (
    <Tags
      selected={selected}
      selectable={selectable}
      onDeselect={onUnselect}
      onSelect={onSelect}
      buttonText={buttonText}
      buttonPosition={buttonPosition}
    />
  )
}
